export default "__VITE_ASSET__BKqiTfq1__"